import React, { useReducer } from 'react'
import InvoiceContext from './invoiceContext'
import InvoiceReducer from './invoiceReducer'
import { apiCall, apiCallSeller } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_INVOICE,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_USER_INVOICES,
    GET_ALL_USER_TRANSACTIONS,
    GET_ALL_INVOICES,
    GET_MULTIPLE_INVOICE,
    GET_SINGLE_INVOICE,
    GET_VIEW_DOC,
    GET_INVOICE_DETAILS,
} from './invoiceTypes'

const InvoiceState = (props) => {
    const initialState = {
        search_allinvoiceproducts: {
            invoicerecords: [],
            transactionrecords: [],
            appointmentrecord: {},
            locationrecord: {},
            cartvalues: {},
            invoiceuserrecords: [],
            invoiceaddressrecord: [],
            invoicesellerrecord: [],
            invoice_notes_public: [],
            invoicebillingaddress: {},
            returnTransactions: [],
            from: '',
        },
        multiple_invoice: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_alluserinvoices: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
            fetched: false,
            sorts: {},
        },
        search_allusertransactions: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        view_doc: {
            records: [],
            from: '',
        },
        all_invoices: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        single_invoice: {
            invoicerecords: [],
            transactionrecords: [],
            appointmentrecord: {},
            locationrecord: {},
            cartvalues: {},
            from: '',
        },
        template_id: {
            id: '',
            from: '',
        },
        invoice_details: {
            invoicerecords: [],
            transactionrecords: [],
            appointmentrecord: {},
            locationrecord: {},
            cartvalues: {},
            orderControlLogs: [],
            from: '',
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(InvoiceReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllInvoiceProducts = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    fromVariable == 'public' ? 'public_invoice' : 'invoice',
                    formData,
                    '',
                    'invoice',
                ),
            ])
            const from = fromVariable ? fromVariable : 'invoicesearch'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_INVOICE,
                    payload: {
                        invoicerecords: res.data.data.responseData.invoiceItems.length
                            ? res.data.data.responseData.invoiceItems
                            : [],
                        transactionrecords: res.data.data.responseData.allTransactions.length
                            ? res.data.data.responseData.allTransactions
                            : [],
                        appointmentrecord: res.data.data.responseData.appointmentDetail,
                        locationrecord: res.data.data.responseData.locationDetail,
                        cartvalues: res.data.data.responseData.cartValues,
                        invoiceuserrecords: res.data.data.responseData.invoiceUser.length
                            ? res.data.data.responseData.invoiceUser
                            : [],
                        invoiceaddressrecord: res.data.data.responseData.invoiceAddress
                            ? res.data.data.responseData.invoiceAddress
                            : [],
                        invoicesellerrecord: res.data.data.responseData.invoiceSeller
                            ? res.data.data.responseData.invoiceSeller
                            : [],
                        invoicebillingaddress: res.data.data?.responseData?.billingAddress
                            ? res.data.data?.responseData?.billingAddress
                            : {},
                        invoice_notes_public: res?.data?.data?.responseData?.invoice_notes_public
                            ? res?.data?.data?.responseData?.invoice_notes_public
                            : [],
                        returnTransactions: res?.data?.data?.responseData?.returnTransactions
                            ? res?.data?.data?.responseData?.returnTransactions
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllReturnInvoice = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'returninvoice', formData, '', 'invoice'),
            ])
            const from = 'invoicesearch'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_INVOICE,
                    payload: {
                        invoicerecords: res.data.data.responseData.invoiceItems.length
                            ? res.data.data.responseData.invoiceItems
                            : [],
                        transactionrecords: res.data.data.responseData.allTransactions.length
                            ? res.data.data.responseData.allTransactions
                            : [],
                        appointmentrecord: res.data.data.responseData.appointmentDetail
                            ? res.data.data.responseData.appointmentDetail
                            : [],
                        locationrecord: res.data.data.responseData.locationDetail
                            ? res.data.data.responseData.locationDetail
                            : [],
                        cartvalues: res.data.data.responseData.cartValues,
                        invoiceuserrecord: res.data.data.responseData.invoiceUser
                            ? res.data.data.responseData.invoiceUser
                            : [],
                        invoiceaddressrecord: res.data.data.responseData.invoiceAddress
                            ? res.data.data.responseData.invoiceAddress
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getMultipleInvoice = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCallSeller('post', 'multipleInvoice', formData, '', 'user/invoice'),
            ])
            const from = fromVariable ? fromVariable : 'MultipleInvoice'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_MULTIPLE_INVOICE,
                    payload: {
                        records: res.data.data.responseData.length
                            ? res.data.data.responseData
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllUserInvoices = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'allinvoices', formData, '', 'invoice'),
            ])
            const from = fromVariable ? fromVariable : 'allinvoices'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_USER_INVOICES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData?.sorts || {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('cartsearch')
        }
    }

    const getAllSellerUserInvoices = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'invoices', formData, '', 'seller/invoice'),
            ])
            const from = 'allinvoices'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_USER_INVOICES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                        fetched: true,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('cartsearch')
        }
    }

    const getAllUserTransactions = async (formData, fromVariable) => {
        const from = 'alltransactions'
        try {
            const [res] = await Promise.all([apiCall('post', from, formData, '', 'invoice')])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_USER_TRANSACTIONS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const getAllInvoices = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'invoices', formData, '', 'seller/invoice'),
            ])
            const fromVariable = from ? from : 'Invoices'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_INVOICES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const createPandaDocForSV = async (formData, fromVariable = 'createPandaDoc') => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'createPandaDocForSV', formData, '', 'user/third_party/pandadoc'),
            ])

            if (res.data.status === 'success') {
                console.log(res.data.data.responseData, 'reeee')
                dispatch({
                    type: GET_DOC_ID,
                    payload: {
                        id: res.data.data.responseData.id ? res.data.data.responseData.id : '',
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeProductStatus = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'productchange'
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'seller/invoice'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const viewPandaDoc = async (formData, fromVariable = 'viewPandaDoc') => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'viewPandaDoc', formData, '', 'user/third_party/pandadoc'),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_VIEW_DOC,
                    payload: {
                        records: res.data.data.responseData.length
                            ? res.data.data.responseData
                            : [],
                        from: fromVariable,
                    },
                })

                // dispatch({
                //     type: GET_FILES,
                //     payload: {
                //         records: res.data.data.responseData.files
                //             ? res.data.data.responseData.files
                //             : [],
                //         from: fromVariable,
                //     },
                // })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleInvoice = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'invoice', formData, '', 'seller/user/invoice'),
            ])
            const from = fromVariable ? fromVariable : 'InvoiceManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_INVOICE,
                    payload: {
                        invoicerecords: res.data.data.responseData.invoiceItems.length
                            ? res.data.data.responseData.invoiceItems
                            : [],
                        transactionrecords: res.data.data.responseData.allTransactions.length
                            ? res.data.data.responseData.allTransactions
                            : [],
                        appointmentrecord: res.data.data.responseData.appointmentDetail
                            ? res.data.data.responseData.appointmentDetail
                            : [],
                        locationrecord: res.data.data.responseData.locationDetail
                            ? res.data.data.responseData.locationDetail
                            : [],
                        cartvalues: res.data.data.responseData.cartValues,
                        invoiceuserrecord: res.data.data.responseData.invoiceUser
                            ? res.data.data.responseData.invoiceUser
                            : [],
                        invoiceaddressrecord: res.data.data.responseData.invoiceAddress
                            ? res.data.data.responseData.invoiceAddress
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateInvoice = async (formData) => {
        try {
            const from = 'invoiceupdate'
            const [res] = await Promise.all([
                apiCall('post', 'update_invoice', formData, '', 'seller/user/invoice'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSessionId = async (formData) => {
        try {
            const from = 'getSessionId'
            const [res] = await Promise.all([
                apiCall('post', 'getSessionId', formData, '', 'user/third_party/pandadoc'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getInvoiceDetails = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCallSeller('post', 'getInvoiceDetails', formData, '', 'invoice'),
            ])
            const from = fromVariable ? fromVariable : 'InvoiceDetails'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_INVOICE_DETAILS,
                    payload: {
                        invoicerecords: res.data.data.responseData.invoiceItems.length
                            ? res.data.data.responseData.invoiceItems
                            : [],
                        transactionrecords: res.data.data.responseData.allTransactions.length
                            ? res.data.data.responseData.allTransactions
                            : [],
                        appointmentrecord: res.data.data.responseData.appointmentDetail
                            ? res.data.data.responseData.appointmentDetail
                            : [],
                        locationrecord: res.data.data.responseData.locationDetail
                            ? res.data.data.responseData.locationDetail
                            : [],
                        cartvalues: res.data.data.responseData.cartValues,
                        invoiceuserrecord: res.data.data.responseData.invoiceUser
                            ? res.data.data.responseData.invoiceUser
                            : [],
                        invoiceaddressrecord: res.data.data.responseData.invoiceAddress
                            ? res.data.data.responseData.invoiceAddress
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <InvoiceContext.Provider
            value={{
                all_invoices: state.all_invoices,
                template_id: state.template_id,
                search_allinvoiceproducts: state.search_allinvoiceproducts,
                search_alluserinvoices: state.search_alluserinvoices,
                search_allusertransactions: state.search_allusertransactions,
                single_invoice: state.single_invoice,
                invoice_details: state.invoice_details,
                multiple_invoice: state.multiple_invoice,
                responseStatus: state.responseStatus,
                view_doc: state.view_doc,
                clearResponse,
                getAllInvoiceProducts,
                getSessionId,
                getMultipleInvoice,
                getAllReturnInvoice,
                getAllUserInvoices,
                updateInvoice,
                getAllUserTransactions,
                viewPandaDoc,
                createPandaDocForSV,
                getAllInvoices,
                changeProductStatus,
                getSingleInvoice,
                getAllSellerUserInvoices,
                getInvoiceDetails,
            }}
        >
            {props.children}
        </InvoiceContext.Provider>
    )
}

export default InvoiceState
